import ShippingModal from './ShippingModal.vue'

export default ShippingModal
